// extracted by mini-css-extract-plugin
export default {"success":"Success_success__zjUpm","infoGrid":"Success_infoGrid__5XJbc","card":"Success_card__dy2Nj"};